import React from "react"
import Dashboard from "./pages/dashboard"
import Debug from "./pages/debug"
import DebugTest from "./pages/debugTest"
import { Toaster } from "react-hot-toast"
import { BrowserRouter as Router, Route, Routes } from "react-router-dom"
import Logs from "./pages/logs"
import NotFound from "./pages/notFound"

function App() {
  const urlParams = new URLSearchParams(window.location.search)
  const userId = urlParams.get("userId")

  return (
    <Router>
      <div className="App">
        <Routes>
          <Route path="/" element={<Dashboard userId={userId} />} />
          <Route path="/debugTest" element={<DebugTest userId={userId} />} />
          {process.env.REACT_APP_ENV !== "production" && (
            <>
              <Route path="/debug" element={<Debug />} />
              <Route path="/logs" element={<Logs />} />
            </>
          )}

          {/* Fallback Route for 404 - Page Not Found */}
          <Route path="*" element={<NotFound />} />
        </Routes>
        <Toaster position="top-right" />
      </div>
    </Router>
  )
}

export default App
